import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import {
  Icon,
  Button,
} from '@material-ui/core';

class StageViewerBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      file: "",
    };
    autoBind(this);
  }

  stageSettingsClicked() {
    this.props.parent.editStage();
  }

  newStageElementClicked() {
    this.props.parent.addStageElement();
  }

  uploadClicked() {
    if (this.stageHasFile()) {
      this.props.root.refs.stageViewerPage.reuploadFile();
    }
    else {
      this.props.root.refs.stageViewerPage.uploadFile();
    }
  }

  stageHasFile() {
    let result = false;
    if (this.props.parent.state.selectedStage != null) {
      if (this.props.parent.state.selectedStage['movie_list'].length > 0) {
        result = true;
      }
    }
    return result;
  }

  render() {
    return (
      <div ref="div" style={{padding:"10px 0 10px 10px"}}>
        <Button
          color="secondary"
          onClick={this.props.root.goBackHistory}
        >
          <Icon className="buttonIconLeft">arrow_back</Icon>
          {Localization.strings.BACK}
        </Button>
        <Button
          color="primary"
          onClick={this.props.parent.createNewStage}
        >
          <Icon className="buttonIconLeft">add</Icon>
          {Localization.strings.NEW_STAGE}
        </Button>
        <If condition={this.props.parent.state.selectedStage != null}>
          <Then>
            <Button
              color="primary"
              onClick={this.stageSettingsClicked}
            >
              <Icon className="buttonIconLeft">settings</Icon>
              {Localization.strings.STAGE_SETTINGS}
            </Button>
            <Button
              color="primary"
              onClick={this.uploadClicked}
              disabled={!this.stageHasFile()}
            >
              <Icon className="buttonIconLeft">cloud_upload</Icon>
              {Localization.strings.RE_UPLOAD}
            </Button>
            <Button
              disabled={!this.stageHasFile()}
              color="primary"
              onClick={this.newStageElementClicked}
            >
              <Icon className="buttonIconLeft">add</Icon>
              {Localization.strings.NEW_STAGE_ELEMENT}
            </Button>
          </Then>
        </If>
      </div>
    )
  }
}

export default StageViewerBar;
